'use strict';

function EmploymentInfo() {
  this.extends = [_AccountController];
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.history = new History();
  this.analytics = new Analytics();
  this.dataSanitization = new DataSanitization();

  this._onFormSubmitCallback = null;
  this.formAction = 'account.edit_member';

  this.init = function () {
    this._super();

    // failed min reqs or completed steps in this set
    if (!this.hasVerifiedEmail() || this.hasAllProfileInfo()) {
      this.routeToNextStep();
    }

    this._$node = $(this.node);

    // Cache the form
    this._$form = this._$node.find('.js--onboarding-form')[0];

    // Form inputs
    this._$formInputs = {
      // Address
      address: this._$node.find('.js--form-address'),
      // Dob
      birthDate: this._$node.find('.js--form-birth-date'),
      // Product of Interest
      productInterests: this._$node.find('.js--products-of-interest'),
      // Credit Request
      requestCreditAmount: this._$node.find('.js--form-requested-credit-amount'),
      // Employment
      annualContainer: this._$node.find('.js--annual-income-container'),
      averagePaycheckAmount: this._$node.find('.js--form-average-paycheck-amount'),
      creditRequested: this._$node.find('.js--credit-requested'),
      employmentInfomation: this._$node.find('.js--form-employment-info'),
      employmentLengthOption: this._$node.find('.js--employment-length-option'),
      employmentType: this._$node.find('.js--form-employment-type'),
      employmentSection: this._$node.find('.js--form-employment-section'),
      employedTitle: this._$node.find('.js--form-employed'),
      grossAnnualIncome: this._$node.find('.js--form-gross-annual-income'),
      hourly: this._$node.find('.js--form-hourly'),
      hourlyOption: this._$node.find('.js--hourly-option'),
      hourlyCalcText: this._$node.find('.js--calulated-yearly-from-paycheck'),
      loanInterest: this._$node.find('.js--form-loan'),
      paychequeContainer: this._$node.find('.js--paycheque-container'),
      payTypeContainer: this._$node.find('.js--employment-pay-option'),
      monthsEmployed: this._$node.find('.js--form-months-employed'),
      monthsEmployedContainer: this._$node.find('.js--months-employed-container'),
      possibleEmploymentOption: this._$node.find('.js--possible-employment-option'),
      possibleOption: this._$node.find('.js--possible-option'),
      salary: this._$node.find('.js--form-salary'),
      residentialStatus: this._$node.find('.js--form-residential-status'),
      residentialMonthlyCost: this._$node.find('.js--form-residential-monthly-cost'),
      selfEmployedTitle: this._$node.find('.js--form-self-employed'),
      salaryCalcText: this._$node.find('.js--calulated-yearly-from-salary'),
      salaryFrequency: this._$node.find('.js--form-salary-frequency'),
      salaryOption: this._$node.find('.js--salary-option'),
      salaryType: this._$node.find('.js--form-salary-type'),
      timeEmployedAmp: this._$node.find('.js--time-employed-seperator'),
      yearsEmployed: this._$node.find('.js--form-years-employed'),
      // Submit
      submit: this._$node.find('.js--form-submit')
    };

    this.presenter.extendCustomValidations(this.formAction, {
      _hooks: { prehook: this._prehook.bind(this) }
    });

    // Setup Input Fields
    if (this._$formInputs.birthDate.length) {
      this._setupDateInput();
    }

    // Form submit approach depends on the section. Employment section schema has a parent node
    // which requires data to be constructed differently before submitting to the BE.
    // Difference for for employment section is data is prepared before submission by using the method
    // performAction instead of addCallbackToAction.

    // Prevent Duplicate entries
    if (this._onFormSubmitCallback) {
      this.presenter.removeCallbackFromAction(this.formAction, this._onFormSubmitCallback);
    }
    this._onEmploymentFormSubmit();

    // show/hide dependant fields UX:
    this._setupEmploymentInput();

    // Form field data transformers
    // Get values to be displayed
    // Set values to be sent to BE
    //   this._extendViewMaps();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    if (this._$form) {
      // cleanup required object so its ready for the next screen
      delete this._$form.mogo().schema.required;
      if (this._onFormSubmitCallback) {
        this.presenter.removeCallbackFromAction(this.formAction, this._onFormSubmitCallback);
      }
    }
  };

  this._onEmploymentFormSubmit = function () {
    var _this = this;

    $(this._$form).on('submit', function () {
      var data = $(_this._$form).serializeFormToObj(false);
      data = _this._constructData(data);

      _this.presenter.performAction(_this.formAction, data, _this.onFormSubmittedCallback.bind(_this));
    });
  };

  this._prehook = function () {
    this._setRequiredFields();

    if (this._$formInputs.employmentSection.length) {
      // this._$form.mogo().schema.required.push('oneOf');
      // var path = null;
      // this._$form.mogo().removeAllValidationPaths();
      // path = '#/properties/oneOf/0';
      // if (path) this._$form.mogo().addValidationIncludePath(path);
    }
  };

  this._setRequiredFields = function () {
    // Choose required fields based on HTML:
    var requiredFieldNames = [];
    var requiredElements = Array.from(this._$form.elements).filter(function (r) {
      return r.getAttribute('data-mogo-ui-required') === 'true';
    });
    for (var i = 0; i < requiredElements.length; i++) {
      requiredFieldNames.push(requiredElements[i].name);
    }
    if (requiredFieldNames.length > 0) {
      // console.log('OnboardingInfo _prehook: required fields:', requiredFieldNames);
      this._$form.mogo().schema.required = requiredFieldNames;
    }
  };

  this.onFormSubmittedCallback = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage(this._$form, {
        productLabel: 'MogoMember'
      });
    } else if (data && data.errors && data.errors[0].code == 400) {
      $('#Notification').mogo().get();
    } else if (response === 200) {
      // TODO: (once everything completed only):
      // Phase 1 can just turn this on again as is...
      var analyticsData = this.analytics.constructData('Complete Profile');
      var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
      analyticsRequest.send();
      var formAnalyticsID = $('.js--onboarding-form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this.presenter.models.account.updateModel(data, this.onCompletedStep.bind(this));
    } else {
      // what happen?
    }
  };

  this.onCompletedStep = function () {
    this.routeToNextStep(); // _OnboardingCoordinator
  };

  this._extendViewMaps = function () {
    var _viewMapMods = {};

    var noop = function noop() {};

    if (this._$formInputs.employmentSection.length) {
      // nullify children so parent can wrap them up in node blanky
      _viewMapMods['account.employment_type'] = { set: noop };
      _viewMapMods['account.years_employed'] = { set: noop };
      _viewMapMods['account.months_employed'] = { set: noop };
      _viewMapMods['account.salary_type'] = { set: noop };
      _viewMapMods['account.gross_annual_income'] = { set: noop };

      // special parent node blanky that takes care of its children
      _viewMapMods['account.employment_info'] = {
        set: function (value) {
          // get child vals and build up obj:
          var obj = {};
          obj.employment_type = this._$formInputs.employmentType.val();
          // obj.years_employed = this._$formInputs.yearsEmployed.val(); (We only send months data)

          if (this._$formInputs.yearsEmployed.val() != null) {
            var yearsToMonths = parseInt(this._$formInputs.yearsEmployed.val()) * 12;
            obj.months_employed = yearsToMonths + Number(this._$formInputs.monthsEmployed.val());
          } else if (this._$formInputs.monthsEmployed.val() == null) {
            obj.months_employed = this._$formInputs.monthsEmployed.val();
          } else {
            obj.months_employed = Number(this._$formInputs.monthsEmployed.val());
          }

          // Salary
          var sType = this._$formInputs.salaryType.mogo().val();
          if (sType) obj.salary_type = sType[0]; // [0] turns it to string from array

          if (this._$formInputs.grossAnnualIncome.val()) {
            obj.gross_annual_income = Number(this._$formInputs.grossAnnualIncome.val());
          }

          console.log(obj);
          return obj;
        }.bind(this)
      };
    }

    this.presenter.extendViewMap(_viewMapMods);
  };

  this._constructData = function (data) {
    var obj = data;
    for (var key in obj) {
      switch (key) {
        case 'employment_type':
          switch (obj[key]) {
            case 'Pension':
            case 'Disability':
              delete obj.months_employed;
              delete obj.years_employed;
              delete obj.salary_type;
              delete obj.gross_annual_income;
              break;
            case 'Unemployed':
              delete obj.months_employed;
              delete obj.years_employed;
              delete obj.salary_type;
              delete obj.gross_annual_income;
              delete obj.average_paycheck_amount;
              delete obj.salary_frequency;
              break;
            case 'Self-Employed':
              delete obj.salary_type;
              delete obj.average_paycheck_amount;
              delete obj.salary_frequency;
            default:
              break;
          }
          break;

        case 'months_employed':
          if (obj.years_employed != null) {
            var yearsToMonths = parseInt(obj.years_employed) * 12;
            obj[key] = parseInt(obj[key]) + yearsToMonths;
          } else {
            obj[key] = parseInt(obj[key]);
          }
          break;

        case 'average_paycheck_amount':
          if (this._$formInputs.salary.is(':checked')) {
            delete obj[key];
            break;
          }
          // we want to leave characters in and have them fail validation
          if (this._isnum(obj[key])) {
            obj[key] = this.dataSanitization.sanitizeMoney(obj[key]);
          }
          break;

        case 'salary_frequency':
          if (this._$formInputs.salary.is(':checked')) {
            delete obj[key];
            break;
          }
          break;

        case 'gross_annual_income':
          if (this._$formInputs.hourly.is(':checked')) {
            delete obj[key];
            break;
          }
          // we want to leave characters in and have them fail validation
          if (this._isnum(obj[key])) {
            obj[key] = this.dataSanitization.sanitizeMoney(obj[key]);
          }
          break;

        case 'salary_type':
          if (obj[key] != null) {
            obj[key] = obj[key][0] ? obj[key][0] : null;
          }
          break;
      }
    }
    // TEMP remove from switch statement @TODO
    if ('years_employed' in obj) delete obj.years_employed;

    // temp create employment_info obj manually
    obj.employment_info = {};
    for (var key in obj) {
      switch (key) {
        case 'employment_type':
        case 'months_employed':
        case 'salary_type':
        case 'average_paycheck_amount':
        case 'salary_frequency':
        case 'gross_annual_income':
          if (obj[key]) obj.employment_info[key] = obj[key];
          delete obj[key];
        default:
          break;
      }
    }
    return obj;
  };

  this._isnum = function (val) {
    return (/^\d+$/.test(val)
    );
  };

  // ################# Employment Info View #################

  this._setupEmploymentInput = function () {
    // On Start: these need to be hidden only after SchemValidation initiated to calculate correct field positions for resultObj
    this._$formInputs.possibleOption.hide();
    this._$formInputs.possibleEmploymentOption.hide();
    this._$formInputs.creditRequested.hide();
    // Even Listeners
    this._$formInputs.employmentType.on('change', this._toggleEmploymentType.bind(this));
    this._$formInputs.hourly.on('change click', this._toggleSalaryType.bind(this));
    this._$formInputs.salary.on('change click', this._toggleSalaryType.bind(this));
  };

  this._toggleEmploymentType = function (e) {
    var employmentType = String(e.target.value).toLowerCase();
    switch (employmentType) {
      case 'employed':
      case 'maternity leave':
        this._showEmployedAndMaternityOptions();
        break;
      case 'pension':
      case 'disability':
        this._showPensionAndDisabilityOptions();
        break;
      case 'unemployed':
        this._showUnemployedOptions();
        break;
      case 'self-employed':
        this._showSelfEmployedOptions();
        break;
      case '':
        break;
      default:
        return console.error(employmentType + ' is an invalid Employment Type');
    }
  };

  this._showEmployedAndMaternityOptions = function () {
    // Display All fields
    this._$formInputs.possibleOption.hide();
    this._$formInputs.possibleEmploymentOption.show();
    var _hourly = this._$formInputs.hourly;
    var _salary = this._$formInputs.salary;
    // show rest only if previously selected
    if (_hourly.is(':checked')) {
      _hourly.click();
    } else if (_salary.is(':checked')) {
      _salary.click();
    }
    this._$formInputs.grossAnnualIncome.mogo().$placeholder[0].innerHTML = 'Gross annual income';
    this._$formInputs.employedTitle.show();
    this._$formInputs.selfEmployedTitle.hide();
    this.resetFields([this._$formInputs.yearsEmployed, this._$formInputs.monthsEmployed, this._$formInputs.salaryType, this._$formInputs.grossAnnualIncome, this._$formInputs.averagePaycheckAmount, this._$formInputs.salaryFrequency]);
  };

  this._showPensionAndDisabilityOptions = function () {
    this._$formInputs.possibleOption.hide();
    this._$formInputs.possibleEmploymentOption.hide();
    // Display Average Payment & Frequency Fields
    this._$node.find('.js--possible-employment-option, .js--salary-option.js--possible-option').hide();
    this._$node.find('.js--hourly-option.js--possible-option').show();
    this.resetFields([this._$formInputs.yearsEmployed, this._$formInputs.monthsEmployed, this._$formInputs.salaryType, this._$formInputs.grossAnnualIncome, this._$formInputs.averagePaycheckAmount, this._$formInputs.salaryFrequency]);
  };

  this._showUnemployedOptions = function () {
    // Display No fields
    this._$formInputs.possibleOption.hide();
    this._$formInputs.possibleEmploymentOption.hide();
    this.resetFields([this._$formInputs.yearsEmployed, this._$formInputs.monthsEmployed, this._$formInputs.salaryType, this._$formInputs.grossAnnualIncome, this._$formInputs.averagePaycheckAmount, this._$formInputs.salaryFrequency]);
  };

  this._showSelfEmployedOptions = function () {
    this._$formInputs.employedTitle.hide();
    this._$formInputs.payTypeContainer.hide();
    this._$formInputs.hourlyOption.hide();
    this._$formInputs.selfEmployedTitle.show();
    this._$formInputs.employmentLengthOption.show();
    this._$formInputs.salaryOption.show();
    this._$formInputs.grossAnnualIncome.mogo().$placeholder[0].innerHTML = 'Gross annual income (personal)';
    this.resetFields([this._$formInputs.yearsEmployed, this._$formInputs.monthsEmployed, this._$formInputs.salaryType, this._$formInputs.grossAnnualIncome, this._$formInputs.averagePaycheckAmount, this._$formInputs.salaryFrequency]);
  };

  this.resetFields = function (fieldArr) {
    for (var i = 0; i < fieldArr.length; i++) {
      var mogoFieldType = fieldArr[i].data('mogo-ui');
      if (mogoFieldType === 'Select') {
        if (fieldArr[i].val()) fieldArr[i].mogo().setSelectedIndex(0);
      } else if (mogoFieldType === 'BooleanGroup') {
        fieldArr[i].mogo().val(false);
      } else if (fieldArr[i].val()) fieldArr[i].mogo().val('');
      if ($(fieldArr[i]).hasClass('error')) {
        $(fieldArr[i]).parents('.input__container').find('.error').removeClass('error');
        if (mogoFieldType === 'BooleanGroup') {
          $(fieldArr[i]).find('.error').removeClass('error');
        }
      }
    }
  };

  this._toggleSalaryType = function (e) {
    var value = String(e.target.value).toLowerCase();
    this._$formInputs.possibleOption.hide();
    this._$node.find('.js--' + value + '-option').show();
    if (value == 'hourly') {
      this.resetFields([this._$formInputs.grossAnnualIncome]);
    } else {
      this.resetFields([this._$formInputs.averagePaycheckAmount, this._$formInputs.salaryFrequency]);
    }
  };
}